import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-pici",
  "use": "icon-pici-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pici\"><path fill=\"#ffffff\" d=\"M704 320H320a32 32 0 1 1 0-64h384a32 32 0 0 1 0 64z m0 448H320a32 32 0 0 1 0-64h384a32 32 0 0 1 0 64z m64-128H256a32 32 0 0 1-32-32v-192a32 32 0 0 1 32-32h512a32 32 0 0 1 32 32v192a32 32 0 0 1-32 32zM288 576h448v-128H288v128z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol